import { Collapse, Table } from '@mantine/core';
import type { ReactNode } from 'react';

interface TableRowCollapsibleProps {
	children: ReactNode;
	isOpen: boolean;
	columnRows?: number;
}

export function TableRowCollapsible({
	isOpen,
	children,
	columnRows = 100,
}: TableRowCollapsibleProps) {
	return (
		<Table.Td colSpan={columnRows} p={0} m={0}>
			<Collapse in={isOpen} py={0} pb={0}>
				{children}
			</Collapse>
		</Table.Td>
	);
}
